import { lazy, StrictMode, Suspense } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import App from "./App";
import { AuthGate } from "./components/auth-gate";
import { LiveProvider } from "./lib/live";
import { queryClient } from "./lib/query/client";
import { LiveSyncProvider } from "./lib/query/live-sync";
import "./lib/pwa";
import "./index.css";

const container = document.getElementById("root");
if (!container) throw new Error("#root is missing from index.html");

/** Dev only: `import.meta.env.DEV` is false in a build, so the import is dropped with it. */
const Devtools = import.meta.env.DEV
  ? lazy(() => import("@tanstack/react-query-devtools").then((module) => ({ default: module.ReactQueryDevtools })))
  : null;

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthGate>
        <LiveProvider>
          <LiveSyncProvider>
            <App />
          </LiveSyncProvider>
        </LiveProvider>
      </AuthGate>
      {Devtools ? (
        <Suspense fallback={null}>
          <Devtools initialIsOpen={false} buttonPosition="bottom-left" />
        </Suspense>
      ) : null}
    </QueryClientProvider>
  </StrictMode>,
);
